<div class="rt-page">

  <!-- Page header + tab bar -->
  <div class="rt-header">
    <h2><i class="bi bi-arrow-counterclockwise"></i> Returns</h2>
    <p class="rt-subtitle">
      Review and act on returns rung up at the POS. Inbox holds the items waiting on you.
    </p>
  </div>

  <div class="rt-tabs">
    <button
      type="button"
      class="rt-tab"
      [class.active]="tab() === 'inbox'"
      (click)="setTab('inbox')"
    >
      <i class="bi bi-inbox"></i>
      Inbox
      @if (inboxBadgeTotal() > 0) {
        <span class="rt-tab-badge">{{ inboxBadgeTotal() }}</span>
      }
    </button>
    <button
      type="button"
      class="rt-tab"
      [class.active]="tab() === 'history'"
      (click)="setTab('history')"
    >
      <i class="bi bi-clock-history"></i>
      History
    </button>
  </div>

  <!-- History filters (only on the History tab) -->
  @if (tab() === 'history') {
    <div class="rt-filters">
      <div class="rt-filter-row">
        <div class="rt-filter rt-filter-search">
          <i class="bi bi-search"></i>
          <input
            type="text"
            placeholder="Search by return # or original bill #"
            [ngModel]="searchTerm()"
            (ngModelChange)="onSearchChange($event)"
          />
        </div>
        <div class="rt-filter">
          <ng-select
            [items]="STATUS_OPTIONS"
            bindLabel="label"
            bindValue="value"
            [multiple]="true"
            placeholder="Status"
            [ngModel]="selectedStatuses()"
            (ngModelChange)="onStatusChange($event)"
          ></ng-select>
        </div>
        <div class="rt-filter">
          <label>From</label>
          <input
            type="date"
            [ngModel]="startDate()"
            (ngModelChange)="startDate.set($event); onDateRangeChange()"
          />
        </div>
        <div class="rt-filter">
          <label>To</label>
          <input
            type="date"
            [ngModel]="endDate()"
            (ngModelChange)="endDate.set($event); onDateRangeChange()"
          />
        </div>
        <button class="rt-btn ghost" (click)="clearFilters()" type="button">
          Clear
        </button>
      </div>
    </div>
  }

  <!-- Inbox / History results -->
  <div class="rt-results">
    @if (isLoading()) {
      <div class="rt-empty rt-loading">Loading returns…</div>
    } @else if (rows().length === 0) {
      <div class="rt-empty">
        @if (tab() === 'inbox') {
          <i class="bi bi-check-circle"></i>
          <strong>No pending approvals.</strong>
          <p>Nothing needs you right now.</p>
        } @else {
          <i class="bi bi-search"></i>
          <strong>No returns match.</strong>
          <p>Try widening the date range or clearing filters.</p>
        }
      </div>
    } @else {
      <div class="rt-table-wrap">
        <table class="rt-table">
          <thead>
            <tr>
              <th>Return #</th>
              <th>Status</th>
              <th>Original bill</th>
              <th>Customer</th>
              <th>Cashier</th>
              <th class="num">Refund</th>
              <th>When</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (r of rows(); track r.id) {
              <tr
                class="rt-row"
                [ngClass]="statusColor(r.status)"
                (click)="openDetail(r)"
                (keydown.enter)="openDetail(r)"
                tabindex="0"
                role="button"
              >
                <td class="rt-rowno">
                  <span class="rt-rowno-text">
                    {{ r.returnNo || ('#' + r.returnNumber) }}
                  </span>
                  @if (r.refundDocType === 'CREDIT_NOTE') {
                    <span class="rt-pill info">CN</span>
                  }
                </td>
                <td>
                  <span class="rt-status" [ngClass]="statusColor(r.status)">
                    {{ statusLabel(r.status) }}
                  </span>
                  @if (r.reconciliationReason) {
                    <span class="rt-status-detail">{{ r.reconciliationReason }}</span>
                  }
                </td>
                <td>
                  <div class="rt-bill">{{ r.originalBilling.billNo || (r.originalBilling.id | slice:0:8) }}</div>
                  <div class="rt-bill-sub">{{ r.originalBilling.billingDate | date:'shortDate' }} · ₹{{ asNumber(r.originalBilling.grandTotal) | number:'1.2-2' }}</div>
                </td>
                <td>
                  @if (r.customer; as c) {
                    <div>{{ c.name }}</div>
                    @if (c.phone) { <div class="rt-bill-sub">{{ c.phone }}</div> }
                  } @else {
                    <span class="rt-muted">—</span>
                  }
                </td>
                <td>{{ r.cashier?.name || r.cashier?.username || '—' }}</td>
                <td class="num">₹{{ asNumber(r.grandTotalRefunded) | number:'1.2-2' }}</td>
                <td>{{ r.returnedAt | date:'medium' }}</td>
                <td><i class="bi bi-chevron-right rt-row-chev"></i></td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="rt-pagination">
        <div class="rt-pagination-info">
          {{ total() }} {{ total() === 1 ? 'return' : 'returns' }} · Page {{ page() }} / {{ pageCount() }}
        </div>
        <div class="rt-pagination-controls">
          <button class="rt-pg" (click)="goToPage(page() - 1)" [disabled]="page() === 1">
            <i class="bi bi-chevron-left"></i>
          </button>
          @for (p of pageWindow(); track p) {
            <button class="rt-pg" [class.active]="p === page()" (click)="goToPage(p)">{{ p }}</button>
          }
          <button class="rt-pg" (click)="goToPage(page() + 1)" [disabled]="page() === pageCount()">
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>
      </div>
    }
  </div>
</div>
